/**
 * Wirft bei Fehlerantworten (z. B. 503, wenn die externe Sagasser-Datenbank deaktiviert ist) einen Error mit
 * der Servermeldung, damit der Importablauf abbricht statt stillschweigend weiterzulaufen.
 */
async function throwIfNotOk(response) {
  if (response.ok) {
    return true
  }

  let errors = []

  try {
    const body = await response.json()
    errors = body.errors || (body.message ? [ body.message ] : [])
  } catch (e) {
    // kein JSON-Body
  }

  const error = new Error(errors.length ? errors.join('\n') : `HTTP ${response.status}`)
  error.status = response.status
  error.errors = errors

  throw error
}

export default class ProductService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  async create(product, options) {
    const response = await fetch(`${this.baseUrl}/product`, {
      body: JSON.stringify(product),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUrl}/product/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUrl}/product/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUrl}/product`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async getAllForCustomer(customerId, options) {
    const response = await fetch(`${this.baseUrl}/product/customer/${customerId}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async getAllForMe(options) {
    const response = await fetch(`${this.baseUrl}/product/me`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Invitation-Code': options.invitationCode
      }
    })

    return await response.json()
  }

  async getAllForMeNew(options) {
    const response = await fetch(`${this.baseUrl}/product/me/new`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Invitation-Code': options.invitationCode
      }
    })

    return await response.json()
  }

  async getAllForMeForSupplier(supplierId, options) {
    const response = await fetch(`${this.baseUrl}/product/me/supplier/${supplierId}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Invitation-Code': options.invitationCode
      }
    })

    return await response.json()
  }

  /** Artikel eines Lieferanten ohne Kundenbezug (Administration). Liefert [] wenn der Endpunkt nicht verfügbar ist. */
  async getAllForSupplier(supplierId, options) {
    const response = await fetch(`${this.baseUrl}/product/supplier/${supplierId}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    if (!response.ok) {
      return []
    }

    return await response.json()
  }

  /** Eigene Artikel des eingeladenen Lieferanten (Lieferantencode im Header). Liefert [] wenn der Endpunkt nicht verfügbar ist. */
  async getAllForMeAsSupplier(options) {
    const response = await fetch(`${this.baseUrl}/product/supplier/me`, {
      headers: {
        'Invitation-Code': options.invitationCode
      }
    })

    if (!response.ok) {
      return []
    }

    return await response.json()
  }

  async getAllForShortCodeForSupplier(shortCode, supplierId, options) {
    const response = await fetch(`${this.baseUrl}/product/shortCode/${shortCode}/supplier/${supplierId}`, {
      headers: {
        'Invitation-Code': options.invitationCode
      }
    })

    return await response.json()
  }

  async update(id, product, options) {
    const response = await fetch(`${this.baseUrl}/product/${id}`, {
      body: JSON.stringify(product),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }


  async import(options) {
    const response = await fetch(`${this.baseUrl}/product/import/sql`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await throwIfNotOk(response)
  }
}